module.exports = __webpack_public_path__ + "img/palm1_1.535744b4.png";